import axios from 'Src/helpers/api/axiosInstance';
import { AppUser } from 'Src/views/App/App';

export function addTournamentTeamGroupIds(user: AppUser, tournamentId: string, data) {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key }
  };

  return axios
    .post(`${window.apiBase}/i/schools/${activeSchoolId}/tournaments/${tournamentId}/teams/groupIds`, data, config)
    .then(response => {
      return response.data;
    });
}

export function assignTournamentTag(user: AppUser, data, tournamentId: string) {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key }
  };

  return axios
    .post(`${window.apiBase}/i/schools/${activeSchoolId}/tournaments/${tournamentId}/tournamentTags`, data, config)
    .then(response => {
      return response.data;
    });
}

export function deleteTournamentTagByTournament(user: AppUser, tournamentId, tournamentTagId) {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key }
  };

  return axios
    .delete(
      `${window.apiBase}/i/schools/${activeSchoolId}/tournaments/${tournamentId}/tournamentTags/${tournamentTagId}`,
      config
    )
    .then(response => {
      return response.data;
    });
}
